import axios from 'axios'

const API_URL = process.env.MIX_API_URL === undefined ? '/api' : process.env.MIX_API_URL + '/api';

export default () => {
  const API = axios.create({
    baseURL: `${API_URL}`
  })

  return API
}
